import ChatModel from "../model/chat_model";

export const toChatModel = (object) => {
    const data = object.data[0];
    const id = data._id;
    const chatName = data.channelName;
    const avatarName = data.channelName;
    const avatarId = data.avatars[0].avatarId;
    const created = data.created ? new Date(data.createdAt) : new Date();
    return new ChatModel({
        id: id,
        chatName: chatName,
        avatarName: avatarName,
        avatarId: avatarId,
        created: created,
    });
}


